<template>
  <div style="width: 100%; height: 100%">
    <div class="index-quality">
      <div
        class="w1200 animate_top in index-quality-box"
        style="display: block"
      >
        <h2>品质选择，值得信赖</h2>
        <div class="index-quality-form">
          <img
            class="index-quality-form-phone"
            src="../../../../../assets/img/phone.png"
            alt=""
          />
          <input
            class="index-quality-form-input"
            id="index-quality-form"
            maxlength="11"
            type="text"
            placeholder="请输入手机号码"
          />
          <div class="index-quality-form-line"></div>
          <button class="index-quality-form-btn">
           免费体验
          </button>
        </div>
        <ul class="index-quality-list">
          <li>
            <img
              src="../../../../../assets/img/tick.png"
              alt=""
            />免费上门或线上产品演示
          </li>
          <li>
            <img
              src="../../../../../assets/img/tick.png"
              alt=""
            />专业客户顾问全程服务
          </li>
          <li>
            <img
              src="../../../../../assets/img/tick.png"
              alt=""
            />企业定制化解决方案
          </li>
          <li>
            <img
              src="../../../../../assets/img/tick.png"
              alt=""
            />全天候业务咨询服务
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formObject
} from "../../../../../config/elementObject.js";
let formObjectTemp = JSON.parse(JSON.stringify(formObject));
export default {
  name: "MkPhonebottomWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "表单",
          type: "form",
        },
      ],
      data: {
        customField1: formObjectTemp,
      },
    };
  },
};
</script>


<style lang="scss" scoped>
.index-quality {
  background-size: 100% 100%;
  height: 100%;
}
.index-quality-box h2 {
  font-size: 26px;
  font-weight: bold;
  line-height: 26px;
  letter-spacing: 2px;
  color: #ffffff;
  padding-top: 30px;
  text-align: center;
  padding-bottom: 30px;
  margin: 0 auto;
}
.index-quality-form {
  width: 636px;
  height: 40px;
  align-items: center;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 1px #fdddd3;
  display: flex;
  .index-quality-form-phone {
    width: 18px;
    height: 20px;
    margin-left: 23px;
    margin-right: 9px;
  }
  .index-quality-form-input {
    flex: 1;
    line-height: 38px;
    font-size: 16px;
    color: #b3b3b3;
  }
  input {
    border-width: 0;
    border-color: white;
    border-style: none;
    background: none;
    outline: none;
  }
  input::-webkit-input-placeholder {
    color: #b3b3b3;
    font-size: 16px;
  }
  .index-quality-form-line {
    width: 1px;
    height: 20px;
    background-color: #e5e5e5;
  }
  .index-quality-form-btn {
    font-size: 18px;
    font-weight: bold;
    line-height: 26px;
    letter-spacing: 1px;
    color: #e50b18;
    margin-left: 35px;
    margin-right: 30px;
    border: none;
    background: none;
  }
}

.index-quality-list {
  overflow: hidden;
  width: 836px;
  margin: 38px auto;
  list-style: none;

  li {
    float: left;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 1px;
    color: #fff1f2;
    padding-right: 20px;
  }
  img {
    vertical-align: middle;
    margin-right: 8px;
  }
}
</style>
